module.exports = __webpack_public_path__ + "img/logo-icon.55ff8a8c.png";